// 防抖指令
export default {
  install(Vue) {
    Vue.directive('debounce', {
      bind(el, binding) {
        let wait = binding.value;
        if (!wait) { // 若不设置防抖时间，则默认1秒
          wait = 1000;
        }
        let timer;
        el.addEventListener('click', event => {
          if (!timer) { // 第一次执行：不阻止click
            timer = setTimeout(() => {
              timer = null;
            }, wait);
          } else {
            clearTimeout(timer);
            timer = setTimeout(() => {
              timer = null;
            }, wait);
            event && event.stopImmediatePropagation(); // 阻止后续方法执行
          }
        }, true);
      }
    })
  }
}